import React, { useEffect } from 'react';
import { withView, ViewComponentProps } from '../shared/viewcomponent';
/**
 * Home page for group admin
 */
export const AdminPendingTransComponent = withView((props:ViewComponentProps)=>{
    return <></>
});